import { createStore, applyMiddleware, compose } from 'redux'
import rootReducer from './reducers'
import apiMiddleware from './middleware/apiMiddleware'
import videoServiceMiddleware from './middleware/videoServiceMiddleware'
import dialogMiddleware from './middleware/dialogMiddleware'

export default function configureStore(initialState) {
  return createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(apiMiddleware, dialogMiddleware, videoServiceMiddleware),
      window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
    )
  )
}
